require('./bootstrap');
require('bootstrap');

require('lazyload');

window.plupload = require('plupload');


import PhotoSwipeLightbox from './files/photoswipe/dist/photoswipe-lightbox.esm.js';
import PhotoSwipe from './files/photoswipe/dist/photoswipe.esm.js';

require('owl.carousel');

window.PhotoSwipeLightbox = PhotoSwipeLightbox;
window.PhotoSwipe = PhotoSwipe;
window.addEventListener("load", (event) => {
    $('.nav-link-home').addClass('show');
});

$(function () {


    document.addEventListener("scroll", (event) => {
        let lastKnownScrollPosition = window.scrollY;
        if (lastKnownScrollPosition >= 100) {
            $('#sectionLogoHeader').addClass('hide-header-logo')
        } else {
            $('#sectionLogoHeader').removeClass('hide-header-logo')
        }
    });

    window.addEventListener('sweetAlert', function (e) {
        Swal.fire({
            title: e.detail.title,
            icon: e.detail.icon,
            toast: true,
            showConfirmButton: false,
            position: 'top-right',
            timer: 3000
        });


    });

    window.addEventListener('tooltip', function (e) {
        $('[data-toggle="tooltip"]').tooltip()
    });


    window.addEventListener('closeModal', function (e) {
        $('#' + e.detail).modal('hide');
    })


    window.addEventListener('openModal', function (e) {
        $('#' + e.detail).modal('show');
        $('.card-fixed').addClass('stop-scrolling')
    })
    $(document).ready(function () {

    });
    window.addEventListener('select2', function (e) {
        $('.js-example-basic-multiple').select2();
    });


    jQuery(document).on("click", ".gallery-btn-r", function (e) {
        e.preventDefault();
        let outerContent = jQuery(this).parent()[0];

        let scrollDiv = outerContent.children[2];

        scrollDiv.scrollLeft = scrollDiv.scrollLeft + 200;

        // btnLeft.style.display = 'none'
        // btnRight.style.display = 'unset'
    });

    jQuery(document).on("click", ".gallery-btn-l", function (e) {
        e.preventDefault();
        let outerContent = jQuery(this).parent()[0];

        let scrollDiv = outerContent.children[2];

        scrollDiv.scrollLeft = scrollDiv.scrollLeft - 200;

        // btnLeft.style.display = 'none'
        // btnRight.style.display = 'unset'
    });


    $('.services-section .owl-carousel').owlCarousel({
        stagePadding: 50,
        rtl: true,
        loop: true,
        margin: 10,
        nav: true,
        dots: false,
        responsive: {
            0: {
                items: 2,
                stagePadding: 5,
            },
            400: {
                items: 3
            },
            768: {
                items: 4
            },
            1200: {
                items: 6
            }
        }
    });
    $(".category_slider .owl-carousel .owl-prev span").html("<i class='fa fa-angle-right'></i>");
    $(".category_slider .owl-carousel .owl-next span").html("<i class='fa fa-angle-left'></i>");
    $('.brand_slider .owl-carousel').owlCarousel({
        stagePadding: 50,
        rtl: true,
        loop: true,
        margin: 10,
        nav: true,
        dots: false,
        responsive: {
            0: {
                items: 1.5,
                stagePadding: 5,
            },
            400: {
                items: 4
            },
            768: {
                items: 4
            },
            1200: {
                items: 6
            }
        }
    });
    $(".brand_slider .owl-carousel .owl-prev span").html("<i class='fa fa-angle-right'></i>");
    $(".brand_slider .owl-carousel .owl-next span").html("<i class='fa fa-angle-left'></i>");


    $('#inputSearchHeader').keyup(function (e) {
        clearTimeout(timeoutID);
        const value = e.target.value
        timeoutID = setTimeout(() => findMember(value), 500)
    });

    let timeoutID = null;

    function findMember(str) {

            $('#spinnerLoadingSearch').removeClass('d-none');
            $('#loadingSearch').removeClass('d-none');


            Livewire.emitTo('site.search-modal', 'changeQ', str);
    }


    jQuery(document).on("click", ".btn-services", function (e) {
        e.preventDefault();
        let id = $(this).attr('data-id');
        let title = $(this).attr('data-title');
        let img = $(this).attr('data-image');

        $('#chileSectionTitle').html(title);
        document.getElementById("chileSectionImg").src = img;
        $('.btn-services').removeClass('active');
        $(this).addClass('active')

        if ($('#featureBoxServices').attr('data-id') !== id) {
            $('.loading-feature').removeClass('d-none')
            $('.feature-service').addClass('d-none')
            Livewire.emitTo('site.section.services', 'changePage', id);
            Livewire.emitTo('site.category.page', 'changePage', id);
        }

    });

    let loaderPage = setTimeout(Wt, 200);    // function in offsite js file
    function Wt() {
        $("#preloaderMenu").addClass("navigation--active").removeClass("navigation--loading");
        if (loaderPage)
            clearTimeout(loaderPage)
    }


});
document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.spacer');
    const navDots = document.querySelectorAll('.nav-dot');
    // انتخاب عنصر subnavigation
    const subnavigation = document.querySelector('.subnavigation');
    const nextSectionBtn = document.getElementById('nextSectionBtn');

    const totalSections = sections.length;
    let currentSectionIndex = 0;
    let isTransitioning = false;
    let scrollBuffer = 0;
    const scrollThreshold = 100;
    const fadeInDelay = 150;

    // تابع برای نمایش سکشن فعلی و مخفی کردن بقیه
    function showSection(index) {
        if (index < 0 || index >= totalSections || isTransitioning) return;

        isTransitioning = true;

        // ابتدا همه آیتم‌های fade-in-item در همه سکشن‌ها را مخفی کن
        document.querySelectorAll('.fade-in-item').forEach(item => {
            item.classList.remove('show');
        });

        // حذف کلاس 'active' از سکشن قبلی و اضافه کردن به سکشن جدید
        sections.forEach((section, i) => {
            if (i === index) {
                section.classList.add('active');
            } else {
                section.classList.remove('active');
            }
        });

        // به‌روزرسانی دات‌های ناوبری
        navDots.forEach((dot, i) => {
            if (i === index) {
                dot.classList.add('active');
            } else {
                dot.classList.remove('active');
            }
        });

        currentSectionIndex = index;

        // **منطق اضافه کردن کلاس active به subnavigation**
        if (currentSectionIndex >= 1) { // اگر سکشن دوم (index 1) یا بعد از آن بود
            subnavigation.classList.add('active');
        } else { // اگر سکشن اول (index 0) بود
            subnavigation.classList.remove('active');
        }

        // منطق نمایان شدن تدریجی آیتم‌های داخل سکشن فعال
        const activeSectionItems = sections[currentSectionIndex].querySelectorAll('.fade-in-item');
        activeSectionItems.forEach((item, itemIndex) => {
            setTimeout(() => {
                item.classList.add('show');
            }, (itemIndex * fadeInDelay) + 200);
        });

        // پس از اتمام transition سکشن و ظهور آیتم‌ها، قفل ترنزیشن را آزاد کنید.
        const longestFadeInTime = (activeSectionItems.length > 0 ? (activeSectionItems.length - 1) * fadeInDelay : 0) + 1000;
        setTimeout(() => {
            isTransitioning = false;
            scrollBuffer = 0;
        }, longestFadeInTime);
    }

    // **اضافه کردن Event Listener برای دکمه**
    nextSectionBtn.addEventListener('click', () => {
        if (isTransitioning) return; // اگر در حال ترنزیشن هستیم، کاری نکن

        let nextIndex = currentSectionIndex + 1;
        if (nextIndex >= totalSections) {
            nextIndex = 0; // اگر به آخر رسیدیم، به سکشن اول برگرد
        }
        showSection(nextIndex);
    });

    // مدیریت رویداد اسکرول (چرخ ماوس)
    window.addEventListener('wheel', (event) => {
        if (isTransitioning) {
            event.preventDefault();
            return;
        }

        scrollBuffer += event.deltaY;

        if (scrollBuffer > scrollThreshold) {
            if (currentSectionIndex < totalSections - 1) {
                showSection(currentSectionIndex + 1);
            } else {
                scrollBuffer = 0;
            }
        } else if (scrollBuffer < -scrollThreshold) {
            if (currentSectionIndex > 0) {
                showSection(currentSectionIndex - 1);
            } else {
                scrollBuffer = 0;
            }
        }

        event.preventDefault();
    }, { passive: false });

    // مدیریت رویداد کلیدها (جهت بالا و پایین)
    window.addEventListener('keydown', (event) => {
        if (isTransitioning) return;

        if (event.key === 'ArrowDown') {
            if (currentSectionIndex < totalSections - 1) {
                showSection(currentSectionIndex + 1);
            }
            event.preventDefault();
        } else if (event.key === 'ArrowUp') {
            if (currentSectionIndex > 0) {
                showSection(currentSectionIndex - 1);
            }
            event.preventDefault();
        }
    });

    // مدیریت کلیک روی دات‌های ناوبری جانبی
    navDots.forEach((dot) => {
        dot.addEventListener('click', (event) => {
            event.preventDefault();
            if (isTransitioning) return;

            const targetIndex = parseInt(dot.dataset.sectionIndex);
            if (!isNaN(targetIndex)) {
                showSection(targetIndex);
            }
        });
    });

    // تنظیم اولیه: نمایش سکشن اول در بارگذاری صفحه
    showSection(0);
});


